export default __webpack_public_path__ + "static/media/person_3.6cc5a54f.png";